import React from "react";
import {
  FaUser,
  FaRegImage,
  FaBolt,
  FaFire,
  FaQuestionCircle,
} from "react-icons/fa";
import getImageUrl from "../../utils/imageUtils";
import styles from "../../styles/components/profile/PostComposerCard.module.css";

const PostComposerCard = ({ user, onCompose, centered = false }) => {
  const displayName = user?.fullName || user?.username || "User";

  const openComposer = (postType = "standard") => {
    onCompose?.(postType);
  };

  return (
    <div
      className={`${styles.composerCard} ${
        centered ? styles.centered : ""
      }`.trim()}
    >
      <button
        type="button"
        className={styles.composerButton}
        onClick={() => openComposer("standard")}
      >
        <span className={styles.composerAvatarWrap}>
          {user?.avatar ? (
            <img
              src={getImageUrl(user.avatar)}
              alt={`${displayName} avatar`}
              className={styles.composerAvatar}
            />
          ) : (
            <FaUser className={styles.composerAvatarIcon} />
          )}
        </span>
        <span className={styles.composerPrompt}>
          Have something to share?
        </span>
      </button>
      <div className={styles.composerActions}>
        <button
          type="button"
          className={styles.composerActionButton}
          onClick={() => openComposer("standard")}
        >
          <FaRegImage /> Photo
        </button>
        <button
          type="button"
          className={`${styles.composerActionButton} ${styles.composerActionBattle}`}
          onClick={() => openComposer("battle")}
        >
          <FaBolt /> Battle
        </button>
        <button
          type="button"
          className={`${styles.composerActionButton} ${styles.composerActionFlex}`}
          onClick={() => openComposer("flex")}
        >
          <FaFire /> Flex
        </button>
        <button
          type="button"
          className={`${styles.composerActionButton} ${styles.composerActionAsk}`}
          onClick={() => openComposer("question")}
        >
          <FaQuestionCircle /> Ask
        </button>
      </div>
    </div>
  );
};

export default PostComposerCard;
